import { FaIdBadge, FaMap, FaStar, FaTruck } from "react-icons/fa";
import { FaCakeCandles } from "react-icons/fa6";

interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  colorBg?: string;
  colorText?: string;
}
const StatCard = ({
  icon,
  title,
  colorBg = "bg-white",
  colorText = "text-n-text-green",
}: StatCardProps) => (
  <div
    className={`flex flex-col justify-between ${colorBg} md:h-[290px] h-[200px] w-full sm:w-[180px] md:w-[200px] lg:w-[220px] p-5 rounded-2xl shadow-sm hover:shadow-xl hover:scale-105 group transition-all duration-300`}
  >
    <div
      className={`${colorText} mb-5 transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}
    >
      {icon}
    </div>
    <h3
      className={`font-semibold ${colorText} md:text-2xl text-xl mb-2  transition-colors duration-300`}
    >
      {title}
    </h3>
  </div>
);

export const StatsSectionClear = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container items-center">
        <div className="text-center md:mb-20 mb-12">
          <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
            Confiança que gera resultados
          </h2>
        </div>
        <div className="flex flex-row flex-wrap justify-evenly gap-2">
          <StatCard
            icon={<FaStar className="w-8 h-8" />}
            title="+ de 750.000 clientes atendidos"
            description="Satisfação de nossos clientes em todo o Brasil."
            colorBg="bg-n-bg-green"
            colorText="text-n-text-beige"
          />
          <StatCard
            icon={<FaTruck className="w-8 h-8" />}
            title="+ 200 mil veículos transportados"
            description="Volume que confirma a qualidade do nosso serviço."
            colorBg="bg-n-secondary"
          />
          <StatCard
            icon={<FaMap className="w-8 h-8" />}
            title="+ de 200 bases pelo Brasil"
            description="Proximidade do seu local. Pronto para atender em qualquer região."
            colorBg="bg-n-beige"
          />
          <StatCard
            icon={<FaIdBadge className="w-8 h-8" />}
            title="+ de 10.000 transportadores credenciados"
            description="Capacitados para atender você em qualquer operação."
            colorBg="bg-n-green-s-light"
          />

          <StatCard
            icon={<FaCakeCandles className="w-8 h-8" />}
            title="+ de 15 anos tranportando veículos"
            description="Capacitados para atender você em qualquer operação."
            colorBg="bg-n-bg-2"
          />
        </div>
      </div>
    </section>
  );
};
